import React, { Component } from 'react';
import Box from '../../../hoc/Box/Box';
import classes from './WeekDays.css';

class WeekDays extends Component {
  constructor(props) {
    super(props);
    this.days = [
      {
        name: 'sunday',
        text: 'Su',
      },
      {
        name: 'monday',
        text: 'Mo',
      },
      {
        name: 'tuesday',
        text: 'Tu',
      },
      {
        name: 'wednesday',
        text: 'We',
      },
      {
        name: 'thursday',
        text: 'Th',
      },
      {
        name: 'friday',
        text: 'Fr',
      },
      {
        name: 'saturday',
        text: 'Sa',
      },
    ];
    this.state = {
      days: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      selectedDays: [],
    };
    if (props.selectedDays) {
      props.selectedDays.forEach((d) => {
        this.setState.days[d] = true;
      });
    }
    this.handleChecked = this.handleChecked.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    //console.log('componentWillReceiveProps', nextProps, nextProps.selectedDays.length, this.props.selectedDays);
    if (
      nextProps.selectedDays &&
      nextProps.selectedDays.length !== this.props.selectedDays.length
    ) {
      const copyDays = Object.assign({}, this.state.days);

      nextProps.selectedDays.forEach((d) => {
        copyDays[d] = true;
      });
      //console.log("value printed", copyDays);
      this.setState({ days: copyDays, selectedDays: nextProps.selectedDays });
    }
  }

  handleChecked(e) {
    //console.log(e && e.target, 'target');
    const { selectedDays } = this.state;
    if (e === undefined) {
      this.setState(
        (prevState) => {
          return {
            days: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
          };
        },
        () => {
          let selectedDays = [];
          // console.log("selected days:", selectedDays);
          this.props.handleWeekDaysChange(selectedDays);
          this.props.handleClearSchedule();
          this.props.handleResetValue(false);
        }
      );
    } else {
      //console.log("e", e);
      let dayChecked = e.target.name || e.target.getAttribute('name');

      let dayCheckedValue = true;
      if (selectedDays.indexOf(dayChecked) > -1) {
        dayCheckedValue = false;
      }
      //console.log('dayChecked', dayChecked, dayCheckedValue, this.state.days);
      this.setState(
        (prevState) => {
          prevState.days[dayChecked] = dayCheckedValue;
          //console.log('prevState.days', prevState.days);
          return {
            days: prevState.days,
          };
        },
        () => {
          let selectedDays = Object.entries(this.state.days)
            .filter((dayEntry) => dayEntry[1])
            .map((dayEntry) => dayEntry[0]);
          //console.log("selected days:", selectedDays);
          this.props.handleWeekDaysChange(selectedDays);
        }
      );
    }
  }

  render() {
    //console.log('weekdays.render', this.props, this.state);
    //              console.log('state days',this.state.days);
    // console.log('days',this.days);
    if (!this.props.name) {
      return <h6> WeekDays.name property is undefined </h6>;
    }

    if (this.props.resetValue) {
      // console.log('sakhdkashd');
      this.handleChecked(undefined);
    }
    // console.log("renderes", this.state);
    let resetHtml;
    if (this.props.from !== 'Groups') {
      resetHtml = (
        <Box>
          <button
            style={{ marginLeft: '0px 0px 10px 0px' }}
            id="clearSchedule"
            className={classes.RegularButton}
            onClick={() => this.handleChecked(undefined)}
          >
            Reset Schedule
          </button>
          <br />
          &nbsp;
        </Box>
      );
    } else {
      resetHtml = <div />;
    }
    return (
      <div>
        {resetHtml}
        <div style={{ margin: '0px 0px 10px 0px', color: '#555555' }}>
          Select Days
        </div>

        <div key={this.props.name} className={classes.weekDaysSelector}>
          {' '}
          {this.days.map((day) => {
            const props = { checked: false };
            if (this.state.days[day.name] && !this.props.resetValue) {
              props.checked = 'checked';
            }

            return (
              <span
                style={{
                  marginRight: '3px',
                  display: 'inline-block',
                  marginTop: '10px',
                }}
              >
                <input
                  type="text"
                  id={this.props.name + day.name}
                  key={Math.random()}
                  name={day.name}
                  className={props.checked ? classes.selected : ''}
                  value={this.state.days[day.name] ? 'true' : 'false'}
                  {...props}
                  // onClick={this.handleChecked}
                />
                <label
                  id={day.name}
                  name={day.name}
                  key={day.name + '_label'}
                  htmlFor={this.props.name + day.name}
                  onClick={this.handleChecked}
                  className={props.checked ? classes.selected : ''}
                >
                  {day.text}
                </label>
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

export default WeekDays;
